export default function JournalPanel({ journal }) {
  const formatDate = (ts) => {
    if (!ts) return "—";
    return ts.split("T")[0];
  };

  const typeColor = (type) => {
    if (type === "forex") return "#4A90D9";
    if (type === "commodity") return "#E8A838";
    return "#7B68EE";
  };

  return (
    <div style={card}>
      <h2 style={heading}>Trade Journal</h2>
      <div style={tableWrap}>
        <table style={table}>
          <thead>
            <tr>
              {["Date","Symbol","Type","Strategy","Setup","Entry","Exit","PnL","RR","Result","Notes"].map(h => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!journal?.length ? (
              <tr>
                <td colSpan={11} style={empty}>No trades recorded yet</td>
              </tr>
            ) : (
              journal.map(t => (
                <tr key={t.id} style={tr}>
                  <td style={td}>{t.opened_at ? t.opened_at.split("T")[0] : "—"}</td>
                  <td style={td}>{t.symbol}</td>
                  <td style={td}>
                    <span style={{
                      ...badge,
                      background: t.instrument_type === "forex" ? "#4A90D9"
                        : t.instrument_type === "commodity" ? "#E8A838" : "#7B68EE"
                    }}>
                      {(t.instrument_type || "equity").toUpperCase()}
                    </span>
                  </td>
                  <td style={td}>{t.strategy || "—"}</td>
                  <td style={td}>{t.setup || "—"}</td>
                  <td style={td}>{t.entry_price}</td>
                  <td style={td}>{t.exit_price || "open"}</td>
                  <td style={{
                    ...td,
                    color: t.pnl > 0 ? "#1D9E75" : t.pnl < 0 ? "#e24b4a" : "#888"
                  }}>
                    {t.pnl !== null ? "$" + t.pnl : "—"}
                  </td>
                  <td style={td}>{t.actual_rr || "—"}</td>
                  <td style={td}>
                    <span style={{
                      ...badge,
                      background: t.status === "open" ? "#185FA5"
                        : t.pnl > 0 ? "#0F6E56" : "#993C1D"
                    }}>
                      {t.status === "open" ? "OPEN"
                        : t.exit_reason ? t.exit_reason.toUpperCase() : t.status.toUpperCase()}
                    </span>
                  </td>
                  <td style={{ ...td, color: "#666", maxWidth: "120px" }}>
                    {t.notes || "—"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const card = {
  background: "#1a1a1a",
  borderRadius: "12px",
  padding: "20px",
  border: "1px solid #2a2a2a",
  gridColumn: "1 / -1"
};
const heading = {
  margin: "0 0 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px"
};
const tableWrap = { overflowX: "auto" };
const table = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: "12px"
};
const th = {
  textAlign: "left",
  padding: "8px 10px",
  color: "#666",
  borderBottom: "1px solid #2a2a2a",
  fontWeight: "500",
  whiteSpace: "nowrap"
};
const tr = { borderBottom: "1px solid #1f1f1f" };
const td = {
  padding: "10px",
  color: "#ccc",
  verticalAlign: "middle"
};
const badge = {
  padding: "2px 8px",
  borderRadius: "12px",
  fontSize: "10px",
  color: "#fff",
  fontWeight: "700"
};
const empty = {
  textAlign: "center",
  padding: "20px",
  color: "#555"
};
